import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Layout } from '@/components/layout';
import { LoginForm } from '@/components/auth';
import { Card } from '@/components/ui';

export function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Set document title
  useEffect(() => {
    document.title = 'Login - BiteWise Healthcare Platform';
  }, []);

  // Get the intended destination after login
  const from = location.state?.from?.pathname || '/provider/dashboard';

  const handleAuthSuccess = () => {
    navigate(from, { replace: true });
  };

  const handleSwitchToSignUp = () => {
    navigate('/', { replace: true });
  };

  const handleSwitchToForgotPassword = () => {
    navigate('/forgot-password', { replace: true });
  };

  return (
    <Layout showHeader={true}>
      <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          {/* Auth Form */}
          <Card className="p-8">
            <LoginForm
              onSuccess={handleAuthSuccess}
              onSwitchToSignUp={handleSwitchToSignUp}
              onSwitchToForgotPassword={handleSwitchToForgotPassword}
            />
          </Card>

        </div>
      </div>
    </Layout>
  );
}